module.exports = __webpack_public_path__ + "static/credit_andorra_monei-368304cb83b933a3c684a053176d70d4.svg";